import { Card, Col } from "reactstrap";
import { dynamicImage } from "../../../../utils";
import { SearchDesc } from "../../../../constants";
import { SearchInformationList } from "../../../../data/applications/SearchResult";
import InformationBlock from "./common/InformationBlock";
import { Image } from "../../../../coreComponents/Image";

const SearchBanner = () => {
  return (
    <Col xxl="4" xl="6" className="box-col-12 mt-4">
      <Card className="o-hidden">
        <div className="blog-box blog-shadow">
          <Image className="img-fluid" src={dynamicImage(`blog/blog.jpg`)} alt="blog" />
          <div className="blog-details">
            <p>25 July 2024</p>
            <h4>{SearchDesc}</h4>
            <ul className="blog-social">
              <li>
                <i className="icofont icofont-user"></i>Mark Jecno
              </li>
              <li>
                <i className="icofont icofont-thumbs-up"></i>02 Hits
              </li>
            </ul>
          </div>
        </div>
      </Card>
      {SearchInformationList.map((item, index) => (
        <InformationBlock key={index} item={item} />
      ))}
    </Col>
  );
};

export default SearchBanner;
